import './App.css';
import { ReactDOM, useState } from 'react';
import Login from './components/Login/login';
import Filtre from './components/Find/find';
import Acceuil from './components/Acceuil/acceuil';
import Navbar from './components/Navbar/navBar';
import Contact from './components/Contact/contact';
import About from './components/About/about';
import Error from './components/Error/error';
import {Route,Link,BrowserRouter as Router,Routes,NavLink } from 'react-router-dom'
import Footer from './components/Footer/footer';
import {Switch} from 'react-router-dom'
import Dashboard from './components/dashboard/dashboard';
import Inscrire from './components/Inscrire/inscrire';
import PrivateRoute from './components/privateroute';
import AddObjet from './components/dashboard/addObjet';
import ObjetCommandeView from './components/dashboard/objetCommandeView';
import { UserConnectStatusProvider } from './components/context/userConnectState';
function App() {
  const [isLogin,setIsLogin] = useState(false)
  const updateLogin = ()=>{
      setIsLogin(true)
  }
  return (
    <div className='div'>
      <Router>
          <div className='switch'>

          <UserConnectStatusProvider>
          <Navbar/>

        <Routes>
              <Route exact path='/' element={<Acceuil/>}/>
              {/* <Route exact path='/login' element={<Login onLogin ={updateLogin} />}/> */}
              <Route exact path='/login' element={<Inscrire/>}/>
              <Route exact path='/contact' element={<Contact/>}/>
              <Route exact path='/about' element={<About/>}/> 
              <Route exact path='/dashboard' element={<Dashboard/>}/>
              <Route exact path='/team' element={<ObjetCommandeView/>}/>
             
        </Routes>
            <Footer/>
          </UserConnectStatusProvider>
          </div>
          
        
      </Router>
      {/* <Login/> */}
      {/* <Acceuil/> */}
      {/* <Filtre/> */}
    </div>
  );
}

export default App;
